<template>
  <div>
    <vx-tooltip :delay="tooltipDelay" :text="tooltipText" :tooltipPosition="tooltipPosition">
      <feather-icon
        icon="FileTextIcon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="open"
      />
    </vx-tooltip>
  </div>
</template>

<script>
import axios from '@/http/axios/index.js'
import { BASE_URL } from '@/urls.js'
export default {
  props: {
    tooltipDelay:{
          type:String,
          default:'1.5s'
    },
    tooltipPosition:{
          type:String,
          default:'top'
    },
    tooltipText:{
        type:String,
        default:null
    },
    title: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 400,
    },
    getDigizenUrl:{
      type: Boolean,
      default: false
    },
    dataId: {
      type: String,
      default: '0',
    },
    pathToGetDigizenUrl:{
      type: String,
      default: '/'
    }
  },
  computed: {
    heightPDF() {
      let output = '83'
      /* if(this.$store.state.windowWidth<700){
        output='50';
      } */
      return output
    },
  },
  methods: {
    open() {
      if(this.getDigizenUrl == false){
        if (this.src !== '') {
          window.open(this.src,this.title,`width=${this.width},height=${this.height},left=50,top=50,toolbar=yes`);
        } else {
          this.$vs.notify({
            color: 'warning',
            title: 'Not File attached',
            text: 'Not File attached'
          })
        }
      }else{
        axios.get(this.pathToGetDigizenUrl, { params: {dataId:this.dataId} }).then(res => {
          let url=res.data.url.url
          window.open(url,this.title,`width=${this.width},height=${this.height},left=50,top=50,toolbar=yes`);
        }).catch(err => {
          console.log(err);
        })
      }
    }
  },
}
</script>

<style lang="css" scoped>
/* 1366 x 768 */
.show-pdf {
  display: block;
  border: none;
}
</style>
